import React, { Component } from 'react';
import { connect } from 'react-redux';
// import { deleteOrder } from '../../redux/actions/orders';
// import Status from './Status.jsx';
import Product from '../components/Product.jsx'

import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { withTranslation  } from 'react-i18next';
import { navigateToShopifyStatus } from '../../redux/actions/orders';

export class Order extends Component {
  constructor(props){
    super(props);

    this.state = {
      expanded: true, // Always want it expanded, might change in the future
      orders: props.data.product_list
    };
  }

  expandOrder = () => {
    // let tempState = this.state;
    // tempState.expanded = !tempState.expanded;
    // this.setState(tempState);
  }

  navigateToShopifyStatus = (order_id) => {
    this.props.dispatch(navigateToShopifyStatus(order_id));
  }

  render() {
    let expanded = "";
    if(this.state.expanded){
      expanded = " expanded";
    }
    const { t } = this.props;
    return (
      <div className="order-wrapper">
        <div className="order"  onClick={() => this.expandOrder(this.props.data.index)}>
          <i className="fas fa-bars"></i>
          <Box pl={1} mt={2} mb={2}>
            <Typography component="div" variant="h5">
              {
                !this.props.data.is_shopify ? <p>{ t('order.OrderID') }: <span>{this.props.data.order_id}</span></p> : <p>{ t('order.OrderID') }: <span className='a-style' onClick={() => this.navigateToShopifyStatus(this.props.data.order_id_origin)}>{this.props.data.order_id}</span></p>
              }
              
            </Typography>
            <Typography variant="subtitle1" color="textSecondary" component="div">
              <p>{ t('order.PurchasePlace') }: <span>{this.props.data.purchase_place}</span></p>
              <p>{ t('order.PurchaseDate') }: <span>{this.props.data.purchase_date}</span></p>
              <p>{ t('order.TotalPrice') }: <span>{this.props.data.order_grand_total} {this.props.data.product_price_currency}</span></p>
            </Typography>
          </Box>
        </div>

        {this.props.data.order_id &&
          <div className={"information" + expanded}>
            {/* With material ui, pl 1 = 8 px */}
            <Box style={{ flexGrow: 1}} pl={1} pr={1}>
              <Grid container spacing={2}>
                {
                  this.state.orders.map((order, i) => (
                    <Grid item xs={12} md={4} lg={6} key={order.id}>
                      <Product
                        id={order.id}
                        index={order.id}
                        data={order}
                      />
                    </Grid>
                  ))
                }
              </Grid>
            </Box>
            <div className="information__info">
            </div>
          </div>
        }
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    orders: state.orders,
    login: state.login
  }
}

export default connect(
  mapStateToProps
)(withTranslation()(Order));



// WEBPACK FOOTER //
// ./src/js/components/Order.jsx